/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Aerobic_Te_RangeInputs */

const en_exp_aerobic_te_range = /** @type {(inputs: Exp_Aerobic_Te_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–0.9: No effect. 1–1.9: Minor benefit. 2–2.9: Maintaining fitness. 3–3.9: Improving fitness. 4–4.9: Highly improving. 5.0: Overreaching.`)
};

const de_exp_aerobic_te_range = /** @type {(inputs: Exp_Aerobic_Te_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0–0,9: Kein Effekt. 1–1,9: Gering. 2–2,9: Erhaltend. 3–3,9: Verbessernd. 4–4,9: Stark verbessernd. 5,0: Überbelastung.`)
};

/**
* | output |
* | --- |
* | "0–0.9: No effect. 1–1.9: Minor benefit. 2–2.9: Maintaining fitness. 3–3.9: Improving fitness. 4–4.9: Highly improving. 5.0: Overreaching." |
*
* @param {Exp_Aerobic_Te_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_aerobic_te_range = /** @type {((inputs?: Exp_Aerobic_Te_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Aerobic_Te_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_aerobic_te_range(inputs)
	return de_exp_aerobic_te_range(inputs)
});